import { render } from "./social-callback.vue?vue&type=template&id=b15b4286"
import script from "./social-callback.vue?vue&type=script&lang=js"
export * from "./social-callback.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/auth/social-callback.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b15b4286"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b15b4286', __exports__)) {
    console.log('reload')
    api.reload('b15b4286', __exports__)
  }
  
  module.hot.accept("./social-callback.vue?vue&type=template&id=b15b4286", () => {
    console.log('re-render')
    api.rerender('b15b4286', render)
  })

}


export default __exports__